import { call, put } from "redux-saga/effects";
import SelfSignupActions from "./self-signup.reducer";
import * as api from "../../../Service/api";

export function* getSelfSignup(action) {
	const { selfSignupId } = action;
	// make the call to the api
	const response = yield call(api.getSelfSignup, selfSignupId);

	// success?
	if (response.ok) {
		yield put(SelfSignupActions.selfSignupSuccess(response.data));
	} else {
		yield put(SelfSignupActions.selfSignupFailure(response.data));
	}
}

export function* resendSelfSignup(action) {
	const { id } = action;
	// make the call to the api
	const response = yield call(api.resendSelfSignup, id);

	// success?
	if (response.ok) {
		yield put(SelfSignupActions.resendSelfSignupSuccess(response.data));
	} else {
		yield put(SelfSignupActions.resendSelfSignupFailure(response.data));
	}
}

export function* resendBulkSelfSignup(action) {
	const { invitations } = action;
	// make the call to the api
	const response = yield call(api.resendBulkSelfSignup, invitations);

	// success?
	if (response.ok) {
		yield put(SelfSignupActions.resendBulkSelfSignupSuccess(response.data));
	} else {
		yield put(SelfSignupActions.resendBulkSelfSignupFailure(response.data));
	}
}

export function* getSelfSignups(action) {
	const { businessId, options } = action;
	// make the call to the api
	const response = yield call(api.getSelfSignups, businessId, options);

	// success?
	if (response.ok) {
		yield put(SelfSignupActions.selfSignupAllSuccess(response.data));
	} else {
		yield put(SelfSignupActions.selfSignupAllFailure(response.data));
	}
}

export function* searchInvitations(action) {
	const { businessId, filter, options } = action;
	// make the call to the api

	const response = yield call(api.searchInvitations, businessId, filter, options);

	// success?
	if (response.ok) {
		yield put(SelfSignupActions.invitationSearchSuccess(response.data));
	} else {
		yield put(SelfSignupActions.invitationSearchFailure(response.data));
	}
}

export function* getSelfSignupsCount(action) {
	const { businessId } = action;
	// make the call to the api

	const response = yield call(api.getCountSelfSignups, businessId);

	// success?
	if (response.ok) {
		yield put(SelfSignupActions.selfSignupCountSuccess(response.data));
	} else {
		yield put(SelfSignupActions.selfSignupCountFailure(response.data));
	}
}

export function* getSearchCount(action) {
	const { businessId, filter } = action;
	// make the call to the api

	const response = yield call(api.searchInvitationsCount, businessId, filter);

	// success?
	if (response.ok) {
		yield put(SelfSignupActions.searchCountSuccess(response.data));
	} else {
		yield put(SelfSignupActions.searchCountFailure(response.data));
	}
}

export function* getSelfSignupsFilter(action) {
	const { businessId, filter, options } = action;
	// make the call to the api

	const response = yield call(api.getSelfSignupsFilter, businessId, filter, options);

	// success?
	if (response.ok) {
		yield put(SelfSignupActions.selfSignupFilterSuccess(response.data));
	} else {
		yield put(SelfSignupActions.selfSignupFilterFailure(response.data));
	}
}

export function* deleteSelfSignup(action) {
	const { selfSignupId } = action;
	// make the call to the api
	const response = yield call(api.deleteSelfSignup, selfSignupId);

	// success?
	if (response.ok) {
		yield put(SelfSignupActions.selfSignupDeleteSuccess());
	} else {
		yield put(SelfSignupActions.selfSignupDeleteFailure(response.data));
	}
}

export function* invitationUptakeRequest(action) {
	const { businessId, planId, query, options } = action;
	// make the call to the api
	const response = yield call(api.getInvitationUptake, businessId, planId, query, options);
	// success?
	if (response.ok) {
		yield put(SelfSignupActions.invitationUptakeSuccess(response.data));
	} else {
		yield put(SelfSignupActions.invitationUptakeFailure(response.data));
	}
}

export function* downloadUptakePdf(action) {
	const { businessId, planId, segmentId, tags } = action;
	// make the call to the api
	const response = yield call(api.downloadUptakePdf, businessId, planId, segmentId, tags);
	if (response.ok) {
        // If responseType: 'blob' worked, response.data is already a Blob.
        const blob = response.data instanceof Blob 
            ? response.data 
            : new Blob([response.data], { type: "application/pdf" });

        // 2. Create a temporary URL for the browser to access the blob
        const url = window.URL.createObjectURL(blob);

        // 3. Create a hidden 'a' tag to trigger the download
        const a = document.createElement("a");
        a.style.display = 'none';
        a.href = url;
        
        // You can also try to get the filename from the content-disposition header if available
        a.download = `uptake-report.pdf`; 
        
        document.body.appendChild(a);
        
        // 4. Trigger the download
        a.click();

        // 5. Clean up: remove the element and revoke the URL to free up memory
        window.URL.revokeObjectURL(url);
        a.remove();

        // 6. Finalize the saga action
        yield put(SelfSignupActions.downloadUptakePdfSuccess(response.data));
    } else {
        yield put(SelfSignupActions.downloadUptakePdfFailure(response.data));
    }
}

export function* downloadUptakeCsv(action) {
	const { businessId, planId, segmentId, tags } = action;
	const response = yield call(api.downloadUptakeCsv, businessId, planId, segmentId, tags);
	if (response.ok) {
        const blob = response.data instanceof Blob 
            ? response.data 
            : new Blob([response.data], { type: "text/csv" });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = 'none';
        a.href = url;
        a.download = `invitation_uptake_report.csv`; 
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();

        yield put(SelfSignupActions.downloadUptakeCsvSuccess(response.data));
    } else {
        yield put(SelfSignupActions.downloadUptakeCsvFailure(response.data));
    }
}
